import usePayment from '@/usePayment';

import {
  _primaryControls,
  _increment,
  orderNumber,
  orderDate,
  status,
  paymentType,
  customerName,
  area,
  address,
  totalWeight,
  deliveryFee,
  remarks,
  lastUpdatedBy,
  updatedAt,
  sortable,
} from './base';

export default {
  types: {
    // _primaryControls,
    _selectorControls: {
      width: '2rem',
      name: 'SELECT',
    },
    _increment,
    orderNumber,
    orderDate,
    status,
    paymentType: {
      ...paymentType,
      filter: (val: string) => val,
    },
    customerName,
    area,
    address,
    totalWeight,
    'packages.length': {
      name: 'จำนวนรายการ',
      width: '1fr',
      class: 'text-center',
    },
    deliveryFee,
    remarks,
    lastUpdatedBy,
    updatedAt,
  },
  sortable: [
    'orderNumber',
    'orderDate',
    'status',
    'paymentType',
    'customerName',
    'updatedAt',
  ],
};
